// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"09ed74f2","973":"7af537f4"}[chunkId] + ".chunk.css";
};